export const productTypes = [
    {
        title: 'HVAC & Plumbing Design',
        products: [{
            name: 'LoopCAD',
            title: 'Radiant Heating & Snow Melt',
            description: 'Radiant heating and snow melt design including heating and cooling load calculations, 2D and 3D drawing, automated loop generation and complete hydronic calculations.',
            logo: require('@/assets/img/logos/product/loopcad.png'),
            path: '/product/loopcad',
            tutorial: '/support/tutorial?productLine=loopcad',
            featuresCompare: {
                MJ8: [
                    'All features in Professional Edition, plus...',
                    'ACCA-Approved Manual J (8th Edition) residential heating/cooling load calculations',
                ],
                Professional: [
                    'All features in Standard Edition, plus...',
                    'Residential heat loss calculations',
                    'ASHRAE heating load calculations',
                    'CSA heating/cooling load calculations',
                    'ASHRAE Snow Melt load calculations',
                ],
                Standard: [
                    'Floorplan drawing and importing',
                    'Manual input of heat loads',
                    'Automated drawing of circuits',
                    'Detailed hydronic calculations',
                    'Dynamic 3D views',
                    'OEM Editions for materials lists/quotations',
                ],
            }
        },
        {
            name: 'HeatCAD',
            title: 'Heating & Cooling Loads',
            description: 'Drawing-based residential heating and cooling load calculations, with 3D views. ASHRAE, CSA F280-12, and Manual J<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span> calculation options available.',
            logo: require('@/assets/img/logos/product/heatcad.png'),
            path: '/product/heatcad',
            tutorial: '/support/tutorial?productLine=heatcad',
            featuresCompare: {
                MJ8: [
                    'All features in Professional Edition, plus...',
                    'ACCA-Approved Manual J (8th Edition) residential heating/cooling load calculations'
                ],
                Professional: [
                    'Floorplan drawing and importing',
                    'ASHRAE and CSA residential heat loss calculations',
                    'Dynamic 3D views',
                ],
            }
        },
        {
            name: 'PlumbingCAD',
            title: 'Plumbing Systems',
            description: 'Drawing-based PEX plumbing system takeoffs for residential and commercial projects. Quickly import PDF drawings, trace the plumbing system, and generate an accurate materials list and quotation.',
            logo: require('@/assets/img/logos/product/plumbingcad.png'),
            path: '/product/plumbingcad',
            tutorial: '/support/tutorial?productLine=plumbingcad'
        }]
    },
    {
        title: 'Other Products',
        products: [{
            name: 'LengthWise',
            title: 'Stock Cutting',
            description: 'Calculate and optimize the cutting of linear materials such as pipe, wood, wire, and metal bars.',
            logo: require('@/assets/img/logos/product/lengthwise.png'),
            path: '/product/lengthwise',
        },
        {
            name: 'Custom Software',
            title: 'Custom Software',
            description: 'Desktop and web-based software development for application design and product sizing and selection.',
            logo: require('@/assets/img/logos/product/custom.png'),
            path: '/product/custom',
        }],
    }
]
